import React, { Fragment, useMemo } from "react";
import Seo from "../Slot/seo";
import { Box, Flex, Image, Text, useColorModeValue } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import MobileSearch from "../Search/MobileSearch";
import GameSelector from "../../components/GameComponents/GameSelector/GameSelector";
import GameTypeSelector from "../../components/GameComponents/GameTypeSelector/GameTypeSelector";
import MarqueeList from "../../components/marquee/MarqueeList";
import TopGameBoard from "../../components/GameComponents/TopGameBoard/TopGameBoard";
import { COMMON_WEB_PATH } from "../../constant";
import HomeTitle from "../../components/HomeTitle/HomeTitle";
import useCheckLogin from "../../hook/useCheckLogin";
import useDeviceType from "../../hook/useDeviceType";
import LeaderBoardWrapper from "../../components/GameComponents/LeaderBoard/LeaderBoardWrapper";
import TaiwanMenu from "./TaiwanMenu";
import useWebsiteInfo from "../../hook/useWebsiteInfo";
import GameCatalog from "../../components/GameCatalog/GameCatalog";
import Carousel from "../../components/Carousel/Carousel";

const Home = () => {
  const handleAllGame = useSelector((state) => state.isHandleAllGame);
  const currentCurrency = useSelector((state) => state.isWalletCurrency);
  const { isLogin, isMachineUser, isMachineDomain } = useCheckLogin();
  const boxBg = useColorModeValue("#EBEDFE", "#394367");

  const isMobile = useDeviceType() === "Mobile";

  // 取網站資訊 - 直接獲取預處理好的圖片路徑
  const { images } = useWebsiteInfo();

  const { topGameList } = handleAllGame;

  return (
    <Fragment>
      <Box minH="calc(100vh - 125px)" display="flex" flexDirection="column">
        <Box
          flex="1"
          minH="0" // 這很重要，確保內容不會溢出
          display="flex"
          flexDirection="column"
        >
          <Seo />
          <Box
            as="section"
            px="common-y"
            display={{ base: "block", xl: "none" }}
          >
            <GameTypeSelector />
          </Box>
          {/* <Box as="section" pt="home-space" px="common-y">
        <SubListSelectorV4 forceShowAll gameMainTypeFromProps={"SLOT"} />
      </Box> */}
          {!isMachineDomain && ( //機台域名不顯示
            <Flex
              my={{
                base: "0px",
                md: "10px",
              }}
              flexDirection={{
                base: "column",
                md: "row",
              }}
              gap={{
                base: "10px",
                md: "0px",
              }}
              px={{
                base: "5px",
                md: "0px",
              }}
            >
              <Box
                as="section"
                pt={{
                  base: "5px",
                  md: "0px",
                }}
                w="100%"
              >
                <Carousel />
              </Box>

              {!isMobile ? (
                <LeaderBoardWrapper>
                  <Box
                    w={{
                      base: "100%",
                      md: "35%",
                    }}
                    display={{ base: "none", xl: "block" }}
                    bgImage={`url('${images.TOP_GAMES_BG}')`}
                    bgPosition="center"
                    bgRepeat="no-repeat"
                    bgSize="100%100%"
                    borderRadius={{
                      base: "0px",
                      md: "common",
                    }}
                    py={{
                      base: "20px",
                      md: "35px",
                    }}
                    px={{
                      base: "20px",
                      md: "35px",
                    }}
                    mx={{
                      base: "0px",
                      md: "10px",
                    }}
                  >
                    <TopGameBoard />
                  </Box>
                </LeaderBoardWrapper>
              ) : null}
            </Flex>
          )}

          {/* <Box as="section" pt="home-space" px="common-y">
        <MarqueeList />
      </Box> */}
          <Box
            display={{ base: "flex", md: "none" }}
            justifyContent="space-between"
            alignItems="center"
            gap="5px"
            mt={{
              md: "0px",
              // base: "10px",
            }}
            pt={{
              base: "0px",
              md: "home-space",
            }}
            px={{
              base: "common-y",
              md: "0px",
            }}
            my="5px"
          >
            <MarqueeList />
            <MobileSearch listHidden />
          </Box>

          {/* 手機板熱門遊戲 */}
          {isMobile ? (
            <LeaderBoardWrapper>
              <Box
                w="100%"
                px={{
                  base: "common-y",
                  md: "20px",
                }}
                display={{ base: "block", md: "none" }}
              >
                <TopGameBoard />
              </Box>{" "}
            </LeaderBoardWrapper>
          ) : null}
        </Box>
        <Box
          flex="none" // 確保這部分不會被拉伸
          // overflowY="scroll"
          // h={{
          //   base: "80vh",
          //   md: "auto",
          // }}
        >
          {/* 手機板TOP GAME */}
          <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            px={{
              base: "common-y",
              md: "10px",
            }}
            my="10px"
            display={{ base: "flex", md: "none" }}
          >
            <Flex
              bgImage={`url('${images.TopGameTitleBG}')`}
              bgRepeat={`no-repeat`}
              bgSize={`100% 100%`}
              justifyContent="center"
              alignItems="center"
              w="80%"
            >
              <Image
                src={`${COMMON_WEB_PATH}/FlyDragon/TOPGAME_Title_mobile.svg`}
                w="150px"
                h="25px"
                my="5px"
              />
            </Flex>
            <Box
              bgImage={`url('${images.topGameBG_mobile}')`}
              bgRepeat={`no-repeat`}
              bgSize={`100% 100%`}
              w="100%"
            >
              <GameCatalog
                wrapperClassName={`!px-[0px]`}
                list={topGameList}
                // mainTitle={`BINGO`}
                // swiperProps={{
                //   customPerView: "popular-layout",
                // }}
                isHot
                observeFalse
                //customFixedWidth="155px"
                hiddenHeader
                hideGameName
                fullImageLayout
              />
            </Box>
          </Flex>

          {/* 電腦板TOP GAME */}
          <Box
            px={{ base: "10px", md: "10px" }}
            display={{ base: "none", md: "block" }}
          >
            <HomeTitle gameType="TOP10" />
            <GameCatalog
              wrapperClassName={`!px-[0px]`}
              list={topGameList}
              // mainTitle={`BINGO`}
              // swiperProps={{
              //   customPerView: "popular-layout",
              // }}
              isHot
              observeFalse
              //customFixedWidth="155px"
              hiddenHeader
              customHeight // 自定義高度 輪播的要比較長
            />
          </Box>
          {/* 台灣三寶 */}
          {/* <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            px={{
              base: "common-y",
              md: "10px",
            }}
            my="10px"
          >
            <Box
              bgImage={{
                base: `${images.TWGameBG}`,
                md: "none",
              }}
              bgRepeat={`no-repeat`}
              bgSize={`100% 100%`}
              w="100%"
            >
              <TaiwanMenu />
            </Box>
          </Flex> */}

          <Box
            px={{
              base: "common-y",
              md: "10px",
            }}
          >
            <HomeTitle gameType="EXCLUSIVE" />
            <GameSelector
              gameMainTypeFromProps={"SLOT"}
              customGamePlatform={"EG"}
              hiddenTitle
              // sliceCount={8}
              mb="10px"
              customSubType="exclusiveBrandGames" // 顯示獨家遊戲
            />
          </Box>
          <Box
            p="10px"
            px={{
              base: "common-y",
              md: "10px",
            }}
            mb={{
              base: "60px",
              sm: "0px",
            }}
          >
            {/* <GameCatalogV4
            wrapperClassName={`!px-[0px]`}
            list={topGameList}
            //mainTitle={`BINGO`}
            swiperProps={{
              delay: 1,
              speed: 25000,
              swiperClassName: "custom-swiper-wrapper",
              customPerView: "live-layout",
            }}
            isHot
            observeFalse
            //customFixedWidth="155px"
            hiddenHeader
          /> */}
            <HomeTitle gameType="POPULAR" />
            <GameSelector
              gameMainTypeFromProps={"SLOT"}
              customGamePlatform={"BNG"}
              hiddenTitle
              customSubType="Popular" // 顯示熱門推薦 最多四十個
              //isNew // 顯示最新遊戲標籤
              isHighlight
            />
          </Box>
          {/* <Box px="common-y">
            <GameCatalogV2
              wrapperClassName={`!px-[0px]`}
              list={topGameList}
              mainTitle={`Top`}
              // swiperProps={{
              //   customPerView: "popular-layout",
              // }}
              isHot
              observeFalse
              customFixedWidth="155px"
            />
          </Box>{" "}
          <Box px="common-y">
            <GameCatalogV2
              wrapperClassName={`!px-[0px]`}
              list={newGameList}
              mainTitle={`News`}
            
              observeFalse
              // swiperProps={{
              //   customPerView: "popular-layout",
              // }}
              isHot
              customFixedWidth="155px"
            />
          </Box> */}
          {/* <Box py="home-space" px="common-y">
            <GameSelector
              hiddenTitle
              gameMainTypeFromProps={gameMainTypeFromProps}
            />
          </Box> */}
        </Box>
      </Box>

      {/* 未登入 且判斷是機台 顯示全螢幕半透明黑色背景 讓他按開始遊戲 */}
      {/* {!isLogin && isMachineUser && <StartGameButton />} */}
    </Fragment>
  );
};

export default Home;
